// Shared classes for form controls (44 px+ touch targets, design-file borders).
export const inputClass =
  "min-h-12 w-full rounded-lg border-[1.5px] border-line-strong bg-card px-3 text-[17px] font-medium text-ink outline-offset-2 disabled:opacity-50";
export const labelClass = "flex flex-col gap-1.5 text-sm font-semibold";
export const chipClass =
  "min-h-11 shrink-0 rounded-full border-[1.5px] px-3 text-[13px] text-ink";
export const primaryButtonClass =
  "min-h-[52px] w-full rounded-lg bg-primary px-6 text-[17px] font-semibold text-primary-foreground hover:bg-primary/90 disabled:opacity-50 disabled:hover:bg-primary";
